import React, { useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';
import { Link } from 'react-router-dom';
import getFonts from '../../functions/getFonts';
import getIcons from '../../functions/getIcons/getIcons';

function Footer({ operator }) {
	const [isCormar, setIsCormar] = useState(false);

	useEffect(() => {
		console.log('window----------', window.location);

		if (window.location.hostname.includes('cormar')) setIsCormar(true);
	}, [window.location]);
	// return (
	// <div
	//   className="themes-footer-3"
	//   style={{
	//     background: isCormar && operator && operator.color_codes && operator.color_codes.tertiary_text_color ? operator.color_codes.tertiary_text_color :
	//       operator && operator.color_codes && operator.color_codes.footer_color
	//         ? operator.color_codes.footer_color
	//         : '',
	//     marginTop: '100px',
	//   }}
	// >
	//   <div className="new-container footer-3">
	//     <div className="footer-3-left">
	//       <a href="/">
	//         <img
	//           // src={getIcons('footerLogo', operator)}
	//           src={operator && operator.footer_logo ? operator.footer_logo : ''}
	//           // alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
	//           style={{
	//             // marginTop: '0',
	//             width:
	//               operator && operator.footer_logo_width ? operator.footer_logo_width : '250px',
	//             height: 'auto',
	//           }}
	//           alt=""
	//         />
	//       </a>
	//     </div>
	//     <div
	//       // className={`footer-3-right f-15 p-2 `}
	//       className="footer-3-right f-15 bold-text p-2 "
	//       style={{
	//         color:
	//           operator && operator.color_codes && operator.color_codes.footer_text_color
	//             ? operator.color_codes.footer_text_color
	//             : '#fff',
	//       }}
	//     >
	//       <div>
	//         {operator && operator.name ? operator.name : ''} {new Date().getFullYear()}.
	//       </div>
	//       <div className="my-1">Todos los derechos reservados ©</div>
	//       <div>
	//         <span>Powered by </span>
	//         <a
	//           href="https://kupos.cl"
	//           target="_blank"
	//           style={{
	//             color:
	//               operator && operator.color_codes && operator.color_codes.footer_text_color
	//                 ? operator.color_codes.footer_text_color
	//                 : '#fff',
	//           }}
	//         >
	//           {/* <img
	//             src={getIcons('kuposLogo', 'kuposLogo')}
	//             // alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
	//             className="footer-kupos-logo"
	//             alt=""
	//           /> */}
	//           kupos.cl
	//         </a>
	//       </div>
	//     </div>
	//   </div>
	// </div>

	// return (
	// <div
	//   className="themes-footer-3"
	//   style={{
	//     background: isCormar && operator && operator.color_codes && operator.color_codes.tertiary_text_color ? operator.color_codes.tertiary_text_color :
	//       operator && operator.color_codes && operator.color_codes.footer_color
	//         ? operator.color_codes.footer_color
	//         : '',
	//     marginTop: '100px',
	//   }}
	// >
	//   <div className="new-container footer-3">
	//     <div className="footer-3-left">
	//       <a href="/">
	//         <img
	//           src={operator && operator.footer_logo ? operator.footer_logo : ''}
	//           style={{
	//             width:
	//               operator && operator.footer_logo_width ? operator.footer_logo_width : '250px',
	//             height: 'auto',
	//           }}
	//           alt=""
	//         />
	//       </a>
	//     </div>
	//     <div
	//       className="footer-3-right f-15 bold-text p-2 "
	//       style={{
	//         color:
	//           operator && operator.color_codes && operator.color_codes.footer_text_color
	//             ? operator.color_codes.footer_text_color
	//             : '#fff',
	//       }}
	//     >
	//       {operator && operator.operator_name === 'biaggini' ? (
	//         <React.Fragment>
	//           <div>Buses biaggini 2024.</div>
	//           <div className="my-1">Todos los derechos reservados ©</div>
	//           <div>
	//             <span>Powered by </span>
	//             <a
	//               href="https://kupos.cl"
	//               target="_blank"
	//               style={{
	//                 color:
	//                   operator && operator.color_codes && operator.color_codes.footer_text_color
	//                     ? operator.color_codes.footer_text_color
	//                     : '#fff',
	//               }}
	//             >
	//               kupos.cl
	//             </a>
	//           </div>
	//         </React.Fragment>
	//       ) : (
	//         <React.Fragment>
	//           <div>
	//             {operator && operator.name ? operator.name : ''} {new Date().getFullYear()}.
	//           </div>
	//           <div className="my-1">Todos los derechos reservados ©</div>
	//           <div>
	//             <span>Powered by </span>
	//             <a
	//               href="https://kupos.cl"
	//               target="_blank"
	//               style={{
	//                 color:
	//                   operator && operator.color_codes && operator.color_codes.footer_text_color
	//                     ? operator.color_codes.footer_text_color
	//                     : '#fff',
	//               }}
	//             >
	//               kupos.cl
	//             </a>
	//           </div>
	//         </React.Fragment>
	//       )}
	//     </div>
	//   </div>
	// </div>
	// );

	const styles = {
		newfooter: {
			marginTop: '40px',
			backgroundColor: 'rgb(0 136 205)',
			color: 'white',
			padding: '40px 10px',
		},
		footer: {
			marginTop: '40px',
			backgroundColor: '#b52c1f',
			color: 'white',
			padding: '40px 10px',
		},
		footerContent: {
			display: 'flex',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			maxWidth: '1200px',
			margin: '0 auto',
			marginTop: '20px',
		},
		footerSection: {
			flex: '1',
			marginBottom: '20px',
			minWidth: '200px',
			//   padding: '0 20px',
			marginLeft: '10px',
		},
		footerTitle: {
			fontSize: '14px',
			fontWeight: 'bold',
			marginBottom: '10px',
		},
		link: {
			color: 'white',
			textDecoration: 'none',
			display: 'block',
			marginBottom: '5px',
			fontSize: '14px',
		},
		socialIcons: {
			display: 'flex',
			gap: '20px',
		},
		socialIcon: {
			display: 'inline-block',
			width: '30px',
			height: '30px',
			//   backgroundColor: 'white',
			borderRadius: '50%',
			textAlign: 'center',
			lineHeight: '30px',
			//   color: '#d20913',
			fontWeight: 'bold',
			textDecoration: 'none',
			fontSize: '16px',
		},
		copyright: {
			textAlign: 'center',
			fontSize: '14px',
			//   marginTop: '20px',
			padding: '12px 10px',
			//   borderTop: '1px solid rgba(255, 255, 255, 0.3)',
		},
		border: {
			width: '1px',
			backgroundColor: 'white',
			height: 'auto',
			margin: '0 20px',
		},
	};

	// return (
	// 	<div>
	// 		{operator.operator_name !== 'santarosa' || operator.operator_name !== 'buseslafit' ? (
	// 			<div
	// 				className="themes-footer-3"
	// 				style={{
	// 					background:
	// 						isCormar &&
	// 							operator &&
	// 							operator.color_codes &&
	// 							operator.color_codes.tertiary_text_color
	// 							? operator.color_codes.tertiary_text_color
	// 							: operator && operator.color_codes && operator.color_codes.footer_color
	// 								? operator.color_codes.footer_color
	// 								: '',
	// 					marginTop: '100px',
	// 				}}
	// 			>
	// 				<div className="new-container footer-3">
	// 					<div className="footer-3-left">
	// 						<a href="/">
	// 							<img
	// 								src={operator && operator.footer_logo ? operator.footer_logo : ''}
	// 								style={{
	// 									width:
	// 										operator && operator.footer_logo_width ? operator.footer_logo_width : '250px',
	// 									height: 'auto',
	// 								}}
	// 								alt=""
	// 							/>
	// 						</a>
	// 					</div>
	// 					<div
	// 						className="footer-3-right f-15 bold-text p-2 "
	// 						style={{
	// 							color:
	// 								operator && operator.color_codes && operator.color_codes.footer_text_color
	// 									? operator.color_codes.footer_text_color
	// 									: '#fff',
	// 						}}
	// 					>
	// 						{/* <div>
	//              {operator && operator.operator_name ? (
	//                operator.operator_name.toLowerCase() === 'biaggini' ?
	//                `Buses ${operator.operator_name.charAt(0).toUpperCase() + operator.operator_name.slice(1)} ${new Date().getFullYear()}.` :
	//                `${operator.operator_name.charAt(0).toUpperCase() + operator.operator_name.slice(1)} ${new Date().getFullYear()}.`
	//              ) : ''}
	//            </div> */}
	// 						<div>
	// 							{operator && operator.name
	// 								? operator.name.toLowerCase() === 'biaggini'
	// 									? `Buses ${operator.name.charAt(0).toUpperCase() +
	// 									operator.name.slice(1)} ${new Date().getFullYear()}.`
	// 									: `${operator.name.charAt(0).toUpperCase() +
	// 									operator.name.slice(1)} ${new Date().getFullYear()}.`
	// 								: ''}
	// 						</div>
	// 						<div className="my-1">Todos los derechos reservados ©</div>
	// 						<div>
	// 							<span>Powered by </span>
	// 							<a
	// 								href="https://kupos.cl"
	// 								target="_blank"
	// 								style={{
	// 									color:
	// 										operator && operator.color_codes && operator.color_codes.footer_text_color
	// 											? operator.color_codes.footer_text_color
	// 											: '#fff',
	// 								}}
	// 							>
	// 								kupos.cl
	// 							</a>
	// 						</div>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		) : null}
	// 		{operator.operator_name === 'santarosa' || operator.operator_name === 'buseslafit' ? (
	// 			<div>
	// 				<div style={styles.footer}>
	// 					<div style={styles.footerContent}>
	// 						<div style={styles.footerSection}>
	// 							<a href="/">
	// 								<img
	// 									src={operator && operator.footer_logo ? operator.footer_logo : ''}
	// 									// src={'/assets/santarosa/icons/footer-logo-santa-rosa-pullman.svg'}
	// 									style={{
	// 										width:
	// 											operator && operator.footer_logo_width
	// 												? operator.footer_logo_width
	// 												: '250px',
	// 										height: 'auto',
	// 									}}
	// 									alt=""
	// 								/>
	// 							</a>
	// 						</div>
	// 						<div style={styles.border}></div>

	// 						<div style={styles.footerSection}>
	// 							<div style={styles.footerTitle}>Contáctanos</div>
	// 							<a href="tel:+56572431796" style={styles.link}>
	// 								<strong>Teléfono:</strong> +56 57 2431796
	// 							</a>
	// 							<a href="mailto:contacto@pullmansantarosa.cl" style={styles.link}>
	// 								<strong>Email: </strong>contacto@pullmansantarosa.cl
	// 							</a>
	// 						</div>

	// 						<div style={styles.border}></div>

	// 						<div style={styles.footerSection}>
	// 							<div style={styles.footerTitle}>Información útil</div>
	// 							<a href="/santarosa-privacy-policy" style={styles.link}>
	// 								Políticas de privacidad
	// 							</a>
	// 							<a href="/#terms" style={styles.link}>
	// 								Términos y condiciones
	// 							</a>
	// 						</div>

	// 						<div style={styles.border}></div>

	// 						<div style={styles.footerSection}>
	// 							<div style={styles.footerTitle}>Síguenos</div>
	// 							<div style={styles.socialIcons}>
	// 								<a
	// 									href="https://www.facebook.com/santarosapullman/"
	// 									aria-label="Facebook"
	// 									target="_blank"
	// 									style={styles.socialIcon}
	// 								>
	// 									<img src={'/images/Facebook-icon.png'} alt="Facebook" />
	// 								</a>
	// 								<a
	// 									href="https://www.instagram.com/pullmansantarosa/"
	// 									aria-label="Instagram"
	// 									target="_blank"
	// 									style={styles.socialIcon}
	// 								>
	// 									<img src={'/images/Instagram-icon.png'} alt="Facebook" />
	// 								</a>
	// 								<a
	// 									href="https://x.com/BusesSantaRosa"
	// 									aria-label="Twitter"
	// 									target="_blank"
	// 									style={styles.socialIcon}
	// 								>
	// 									<img src={'/images/Twitter-icon.png'} alt="Facebook" />
	// 								</a>
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</div>
	// 				<div style={styles.copyright}>
	// 					Buses Pullman Santa Rosa {new Date().getFullYear()} © - Todos los derechos reservados |
	// 					Powered by{' '}
	// 					<a href="https://kupos.cl" target="_blank" style={{ fontWeight: '800' }}>
	// 						kupos.cl
	// 					</a>
	// 				</div>
	// 			</div>
	// 		) : null}
	// 	</div>
	// );
	const isSpecialOperator =
		operator && (operator.operator_name === 'santarosa' || operator.operator_name === 'buseslafit');

	const defaultFooterStyle = {
		background:
			isCormar && operator.color_codes.tertiary_text_color
				? operator.color_codes.tertiary_text_color
				: operator.color_codes.footer_color || '',
		marginTop: '100px',
	};

	const footerLogo = operator.footer_logo || '';
	const footerLogoWidth = operator.footer_logo_width || '250px';
	const footerTextColor = operator.color_codes.footer_text_color || '#fff';

	return (
		<div>
			{/* Default Footer */}
			{!isSpecialOperator && (
				<div className="themes-footer-3" style={defaultFooterStyle}>
					<div className="new-container footer-3">
						<div className="footer-3-left">
							<a href="/">
								<img src={footerLogo} style={{ width: footerLogoWidth, height: 'auto' }} alt="" />
							</a>
						</div>
						<div className="footer-3-right f-15 bold-text p-2" style={{ color: footerTextColor }}>
							<div>
								{operator.name
									? operator.name.toLowerCase() === 'biaggini'
										? `Buses ${operator.name.charAt(0).toUpperCase() +
										operator.name.slice(1)} ${new Date().getFullYear()}.`
										: `${operator.name.charAt(0).toUpperCase() +
										operator.name.slice(1)} ${new Date().getFullYear()}.`
									: ''}
							</div>
							<div className="my-1">Todos los derechos reservados ©</div>
							<div>
								<span>Powered by </span>
								<a href="https://kupos.cl" target="_blank" style={{ color: footerTextColor }}>
									kupos.cl
								</a>
							</div>
						</div>
					</div>
				</div>
			)}

			{/* Special Footer for Santa Rosa and other operators */}
			{isSpecialOperator && (
				<div>
					<div>
						<div style={operator.operator_name === 'buseslafit' ? styles.newfooter : styles.footer}>
							<div style={styles.footerContent}>
								{/* Footer Logo */}
								<div style={styles.footerSection}>
									<a href={operator.operator_name === 'buseslafit' ? '#' : '/'}>
										<img
											src={footerLogo}
											style={{ width: footerLogoWidth, height: 'auto' }}
											alt=""
										/>
									</a>
								</div>

								<div style={styles.border}></div>

								{/* Contact Section */}
								<div style={styles.footerSection}>
									<div style={styles.footerTitle}>Contáctanos</div>
									<span href="tel:+56572431796" style={styles.link}>

										<strong>Teléfono:</strong>
										{operator.operator_name === 'buseslafit' ?
											' +56 9 4222 7313' : '+56 57 2431796'}
									</span>

									{/* <a href="mailto:contacto@pullmansantarosa.cl" style={styles.link}> */}


									<span
										// href={
										// 	operator && operator.operator_name === 'buseslafit'
										// 		? "#"
										// 		: "#"
										// }
										style={styles.link}
									>

										<strong>Email:</strong>
										{operator.operator_name === 'buseslafit'
											? ' contacto@buseslafit.cl'
											: ' contacto@pullmansantarosa.cl'}
										{' '}

									</span>
								</div>

								<div style={styles.border}></div>

								{/* Info Section */}
								<div style={styles.footerSection}>
									<div style={styles.footerTitle}>Información útil</div>
									<a
										href={operator.operator_name === 'buseslafit' ? '/buseslafit-privacy-policy' : '/santarosa-privacy-policy'}
										style={styles.link}
									>
										Políticas de privacidad
									</a>
									<a href="/#terms" style={styles.link}>
										Términos y condiciones
									</a>
								</div>

								<div style={styles.border}></div>

								{/* Social Media */}
								<div style={styles.footerSection}>
									<div style={styles.footerTitle}>Síguenos</div>
									<div style={styles.socialIcons}>
										<a
											href={
												operator.operator_name === 'santarosa'
													? 'https://www.facebook.com/santarosapullman/'
													: 'https://www.facebook.com/busesLafit?locale=es_LA'
											}
											aria-label="Facebook"
											target="_blank"
											style={styles.socialIcon}
										>
											<img src="/images/Facebook-icon.png" alt="Facebook" />
										</a>
										<a
											href={
												operator.operator_name === 'santarosa'
													? 'https://www.instagram.com/pullmansantarosa/'
													: 'https://www.instagram.com/buseslafit/'
											}
											aria-label="Instagram"
											target="_blank"
											style={styles.socialIcon}
										>
											<img src="/images/Instagram-icon.png" alt="Instagram" />
										</a>
										<a
											href={
												operator.operator_name === 'santarosa'
													? 'https://x.com/BusesSantaRosa'
													: '#'
											}
											aria-label="Twitter"
											target="_blank"
											style={styles.socialIcon}
										>
											{operator.operator_name === 'santarosa' ? (
												<img src="/images/Twitter-icon.png" alt="Twitter" />
											) : null}
										</a>
									</div>
								</div>
							</div>
						</div>

						{/* Copyright */}
						<div style={styles.copyright}>
							{operator.name
								? operator.name.toLowerCase() === 'biaggini'
									? `Buses ${operator.name.charAt(0).toUpperCase() +
									operator.name.slice(1)} ${new Date().getFullYear()}.`
									: `${operator.name.charAt(0).toUpperCase() + operator.name.slice(1)}.`
								: ''}{' '}
							{new Date().getFullYear()} © - Todos los derechos reservados | Powered by{' '}
							<a href="https://kupos.cl" target="_blank" style={{ fontWeight: '800' }}>
								kupos.cl
							</a>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
const PrivacyPolicy = ({ operator }) => {
	const createMarkup = data => {
		return { __html: data };
	};
	return (
		<div className="themes-theme-two-about-us new-container" style={{ marginTop: -10 }}>
			<div
				className="lh-1-3 justify-text about  "
				style={{
					flex: 1,
					background:
						operator && operator.operator_name !== 'santarosa'
							? operator && operator.color_codes && operator.color_codes.primary_color
							: '#EEF0F1',
					color:
						operator && operator.operator_name !== 'santarosa'
							? operator && operator.color_codes && operator.color_codes.tertiary_text_color
							: '#464647',
				}}
			>
				<div
					className={
						operator && operator.operator_name === 'santarosa' ? 'scrollclass scroll-style' : ''
					}
					dangerouslySetInnerHTML={createMarkup(
						operator && operator.privacy_policy ? operator.privacy_policy : '',
					)}
				/>
			</div>
		</div>
	);
};
export default Footer;



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/Footer.js